/**
* @public
*/
const HlsErrorStrings = {
	WARNING						: 'BamHLS issued a non-fatal warning',
	LOAD_FAILED					: 'BamHLS was not able to load the stream',
	FETCH_FAILED				: 'BamHLS was not able to fetch the variants',
	PLAYBACK_FAILED				: 'BamHLS was not able to playback the media',
	MEDIA_CONTROLLER_FAILED		: 'BamHLS was not able to wire or attach the media',
	MEDIA_ELEMENT_FAILED		: 'BamHLS experienced an error in the media element',
	STREAM_TIMEOUT				: 'BamHLS experienced unexpected stream ending',
	UNEXPECTED_ERROR			: 'BamHLS experienced an unexpected error',
	INTERNAL_EXCEPTION			: 'BamHLS experienced an internal exception',
};

export default HlsErrorStrings;



// WEBPACK FOOTER //
// ./src/HlsErrorStrings.js